import { createFileRoute, notFound, Outlet } from '@tanstack/react-router';

export const Route = createFileRoute('/_authenticated/$mallId')({
  beforeLoad: ({ params }) => {
    if (!/^[a-zA-Z0-9-]+$/.test(params.mallId)) {
      throw notFound();
    }
  },
  component: MallIdLayout,
});

function MallIdLayout() {
  return <Outlet />;
}
